export enum Cookie {
  pluginToken = 'Plugin-Token'
}
